import { render, staticRenderFns } from "./homework.vue?vue&type=template&id=4a538dbf&scoped=true"
import script from "./homework.vue?vue&type=script&lang=ts"
export * from "./homework.vue?vue&type=script&lang=ts"
import style0 from "./homework.vue?vue&type=style&index=0&id=4a538dbf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a538dbf",
  null
  
)

export default component.exports